<!-- 快递运单 -->
<template>
  <div class="content">
    <div class="top">
      <div class="top_left">
        <el-button size="small" @click="gopath(0, 0)">运费模版</el-button>
        <el-button size="small" @click="gopath(1, 0)">配送设置</el-button>
        <el-button size="small" @click="gopath(2, 0)">快递运单</el-button>
      </div>
      <div class="top_right"></div>
    </div>
    <div class="cont">
      <div class="list"
        v-for="(item, index) in initdata"
        :key=index
      >
        <div class="option">
          <div class="name">{{ item.name }}</div>
          <div class="default" v-if="item.is_defautl_tpl == 1">新商品默认模板{{ item.is_default_tpl }}</div>
          <div class="num">使用该模板的商品：<span>0</span>个</div>
          <div class="num">最后编辑时间：<span>{{ item.createtime }}</span>个</div>
          <div class="num" v-if="item.is_defautl_tpl == 0">
            <el-checkbox
              size="mini"
              @change="setdefalut(item.id)"
            >
              <div class="num">默认模板</div>
            </el-checkbox>
          </div>
        </div>
        <!-- 按重量 -->
        <table class="table" v-if="item.calculate_type == '0' ? true: false">
          <thead>
            <tr>
              <td>可配送区域</td>
              <td>首重(kg)</td>
              <td>运费(元)</td>
              <td>续重(kg)</td>
              <td>续费（元）</td>
              <td>操作</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>所有地区</td>
              <td>{{ item.firstweight }}</td>
              <td>{{ item.firstprice }}</td>
              <td>{{ item.secondweight }}</td>
              <td>{{ item.secondprice }}</td>
              <td class="rightline">
                <div class="box flex">
                  <div class="link" @click="edit(item.id)">编辑</div>
                  <div class="link">复制</div>
                  <div class="link" @click="del(item.id)">删除</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 件数 -->
        <table class="table" v-if="item.calculate_type == '1' ? true: false">
          <thead>
            <tr>
              <td>可配送区域</td>
              <td>首件(件)</td>
              <td>运费(元)</td>
              <td>续件（件）</td>
              <td>续费（元）</td>
              <td>操作</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>所有地区</td>
              <td>{{ item.firstnum }}</td>
              <td>{{ item.firstnumprice }}</td>
              <td>{{ item.secondnum }}</td>
              <td>{{ item.secondnumprice }}</td>
              <td class="rightline">
                <div class="box flex">
                  <div class="link" @click="edit(item.id)">编辑</div>
                  <div class="link">复制</div>
                  <div class="link" @click="del(item.id)">删除</div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { getFreights, delFreights, setFreights } from "@/api/express";
import { mapState, mapActions } from "vuex";
export default {
  inject: ["reload"],
  computed:{
    ...mapState({
      "token": state => state.crumbs.token,
      "app_id": state => state.crumbs.app_id,
      "merch_id": state => state.crumbs.merch_id,
    })
  },
  data () {
    return {
      initdata:[]
    };
  },

  components: {},
  mounted(){
    this.getdata();
  },
  methods:{
    ...mapActions(["sethttp"]),
    getdata(){
      this.sethttp("2");
      let data = {
        "token":this.token,
        "app_id":this.app_id,
        "merch_id":this.merch_id,
      }
      getFreights(data).then(res =>{
        console.log("state",res);
        if(res.code == 200){
          this.initdata = res.data;
        }else{
          this.$message(res.msg);
        }
        this.sethttp("1");
      })
    },
    gopath(index, is_Edit){
      console.log("dsssssss",index, is_Edit);
      switch(index){
        case 0:
          if(is_Edit == 0){
            this.$router.push({
              name: "freight_",
              query: {jude: 0}
            });
          }
        break;
        case 1:
          if(is_Edit == 0){
            this.$router.push({
              name: "peisongset",
              query: {jude: 0}
            });
          }
        break;
        case 2:
          if(is_Edit == 0){
            this.$router.push({
              name: "fedex",
              query: {jude: 0}
            });
          }
        break;
      }
    },
    // 编辑
    edit(id){
      this.$router.push({
        name: "freight_",
        query: {jude: 1, id: id}
      });
    },
    // 删除
    del(id){
      let data = {
        "token":this.token,
        "app_id":this.app_id,
        "merch_id":this.merch_id,
        "id": id,
      };
      this.sethttp("2");
      delFreights(data).then(res => {
        console.log("chanchu ", res);
        this.$message({
          type: "success",
          message: res.msg
        });
        this.reload();
        this.sethttp("1");
      });
    },
    // 设置默认
    setdefalut(index) {
      let data = {
        "token":this.token,
        "app_id":this.app_id,
        "merch_id":this.merch_id,
        "id": index,
      };
      this.sethttp("2");
      setFreights(data).then(res => {
        console.log("设置默认 ", res);
        this.$message({
          type: "success",
          message: res.msg
        });
        this.reload();
        this.sethttp("1");
      });
      console.log("我变化了", index);
    }
  }
};
</script>
<style lang="scss" scoped>

.content {
  padding: 0 48px 0 26px;
  height: calc(100% - 74px);
  .top {
    height: 80px;
    display: flex;
    align-items: center;
    .top_left {
      width: 50%;
    }
  }
  .cont {
    height: calc(100% - 80px);
    border: 1px solid rgba(235, 238, 245, 1);
    padding: 22px;
    overflow-y: scroll;
    .list {
      width: 100%;
      border-radius: 5px;
      border: 1px solid #ededef;
      margin-bottom: 5px;
      .option {
        height: 52px;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px 0;
        .name {
          width: 40%;
          color: #595961;
          font-weight: 600;
        }
        .default {
          color: #ff8c00;
        }
        .num {
          font-size: 12px;
          color: #9797a1;
        }
      }
      .table {
        width: 100%;
        tr {
          height: 54px;
          border: 1px solid #ededed;
        }
        td {
          padding-left: 10px;
        }
        .rightline {
          border-left: 1px solid #ededed;
        }
        thead {
          height: 54px;
        }
      }
    }
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .link {
    color: #409eff;
    cursor: pointer;
    padding-right: 10px;
  }
}
</style>
